import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  consultant_fullname?: string;
};

const ConsultantCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    {row?.consultant_fullname && (
      <Tooltip title={row.consultant_fullname}>
        <Typography variant="body2" noWrap>
          {row.consultant_fullname}
        </Typography>
      </Tooltip>
    )}
  </>
));

export default ConsultantCell;
